export default __webpack_public_path__ + "static/media/graph-11.f6d17d7e.png";